/*
 *
 *  actions
 *
 */


import {
 
  LOAD_EW_WISE_DELIVERABLE_STATUS,
  LOAD_EW_WISE_DELIVERABLE_STATUS_SUCCESS,
  LOAD_EW_WISE_DELIVERABLE_STATUS_ERROR,


  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_STATUS,
  LOAD_STATUS_SUCCESS,
  LOAD_STATUS_ERROR
  
//loadEwWiseDeliverableStatus
 
} from "./constants"

export function loadRecordsCacheHit() {
  return {
   // type: LOAD_RECORDS_VALID_CACHE  product_data
  }
}


export function loadEwWiseDeliverableStatus(searchFilter) {
  return {
    type: LOAD_EW_WISE_DELIVERABLE_STATUS,
    searchFilter,
  }
}


export function loadEwWiseDeliverableStatusSuccess(ew_data, success) {
  return {
    type: LOAD_EW_WISE_DELIVERABLE_STATUS_SUCCESS,
    ew_data,
    success,
  }
}


export function loadEwWiseDeliverableStatusError(error) {
  return {
    type: LOAD_EW_WISE_DELIVERABLE_STATUS_ERROR,
    error,
  }
}



export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

export function loadStatus(statusDetails) {
  return {
    type: LOAD_STATUS,
    statusDetails,
  }
}


export function loadStatusSuccess(status_data, success) {
  return {
    type: LOAD_STATUS_SUCCESS,
    status_data,
    success,
  }
}


export function loadStatusError(error) {
  return {
    type: LOAD_STATUS_ERROR,
    error,
  }
}
const actions = {
  loadEwWiseDeliverableStatus,
  loadEwWiseDeliverableStatusSuccess,
  loadEwWiseDeliverableStatusError,


  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadStatus,
  loadStatusSuccess,
  loadStatusError
}

export default actions
